import * as React from "react";
export const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={106} height={106} viewBox="0 0 106 106" {...props}>
      <g transform="translate(-11 -11)">
        <path
          d="M64,14A50,50,0,1,1,14,64,50.018,50.018,0,0,1,64,14"
          fill="transparent"
        />
        <path
          d="M64,117a53,53,0,1,1,53-53A53.091,53.091,0,0,1,64,117ZM64,17a47,47,0,1,0,47,47A47.074,47.074,0,0,0,64,17Z"
          fill="#01579B"
        />
        <path
          d="M64,42.7a3,3,0,1,0,3,3A2.946,2.946,0,0,0,64,42.7ZM64,93a2.946,2.946,0,0,1-3-3V62.3a3,3,0,0,1,6,0V90A2.946,2.946,0,0,1,64,93Z"
          fill="#01579B"
        />
      </g>
    </svg>
  );
};
